"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/LearnerPlate.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var LearnerPlate = function LearnerPlate(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 139 139"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "learner-plate",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M0 139V0h138.9v138.9L0 139zM5.6 5.7v127.7h127.7V5.7H5.6z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M62.4 97.7V20.9h-24v97.2h62.1V97.8l-38.1-.1z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  })));
};
exports.default = LearnerPlate;